import { ComplexValue } from 'app/infrastructure/ui/form/types';
import { PersonOptionsCodes } from 'app/components/access-panel/shared/types';

export const hasPersonOptionsCodes = (personOptionsCodes: PersonOptionsCodes) =>
  !!personOptionsCodes && !personOptionsCodes.fetching && personOptionsCodes.values && personOptionsCodes.values.length > 0;

export const hasPersonOptionsValues = (personOptions: ComplexValue<number>[]) =>
  !!personOptions && personOptions.length > 0;
